<template>
  <van-pull-refresh class="wrapfollow" v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length ? '没有更多了' : ''"
      @load="onLoad"
    >
      <template v-if="list.length">
        <item v-for="(item, index) in list" :key="index" :item="item"></item>
      </template>
      <van-empty v-else description="暂无信息" />
    </van-list>
    <rPage></rPage>
  </van-pull-refresh>
</template>
<script>
import { getSubscribePost } from '@/api/base';
import item from '../components/item';
import rPage from '../components/rPage.vue';
export default {
  components: { item, rPage },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      page: {
        size: 10,
        current: 1,
      },
      list: [],
    };
  },
  created() {},
  methods: {
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      getSubscribePost(this.page).then(res => {
        res.data.records.map(item => {
          item.subscribe = true;
        });
        let tmpList = res.data.records;
        let list = this.list || [];
        if (this.refreshing) {
          list = tmpList;
          this.refreshing = false;
        } else if (tmpList.length) {
          list = [...list, ...tmpList];
        } else {
          this.finished = true;
        }
        this.loading = false;
        this.list = list;
        this.page.current++;
        // this.$toast.clear();
      });
    },
    onRefresh() {
      this.list = [];
      this.refreshing = true;
      this.finished = false;
      this.page = { current: 1, size: 10 };
      // this.onLoad();
    },
  },
};
</script>
<style scoped>
.wrapfollow {
  padding-bottom: 65px;
}
</style>
